// import { TeamMemberProfileProps } from '~/components/atoms/TeamMemberProfile/TeamMemberProfile'
// import styles from './ContributorList.module.css'
// import { ComponentTheme } from '~/components/themes'
// import { Grid, Row, Col } from '~/components/atoms/Grid'
// import Fixture from '~/components/atoms/Fixture/Fixture'
// import Container from '~/components/atoms/Container/Container'
// import { useRef } from 'react'
// import classnames from 'classnames'
// import { useMediaQuery } from '~/services/useMediaQuery'
// import Text, { TextSizes } from '~/components/atoms/Text/Text'
// import Image from '~/components/atoms/Image/Image'
// import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
// import Slider from '~/components/atoms/Slider/Slider'
// import Link from 'next/link'
// import firstLettersConcatenated from '~/utils/firstLetterConcatenated'
// export interface ContributorListProps {
//   list: TeamMemberProfileProps[]
//   theme?: ComponentTheme
//   verticalPadding?: boolean
//   noPaddingBottom?: boolean
//   testID?: string
//   title?: string
//   slug?: string
// }
// const ContributorProfile = ({
//   name,
//   image,
//   jobTitle,
//   articleCount,
//   slug,
// }: TeamMemberProfileProps) => {
//   const hasArticles = articleCount && articleCount > 0
//   const imageLink =
//     hasArticles && !image?.asset
//       ? `/articles?author=${name}#all-articles`
//       : slug
//   return (
//     <div className={styles.contributorWrap}>
//       <Link href={imageLink}>
//         <div className={classnames(styles.avatar)}>
//           {image?.asset ? (
//             <div className={styles.imageWrapper}>
//               <Image
//                 asset={image.asset}
//                 alt={name}
//                 width={96}
//                 loading="eager"
//               />
//             </div>
//           ) : (
//             <div className={styles.intialsFallback}>
//               <Text size={TextSizes.secondaryTitleMicro}>
//                 {firstLettersConcatenated(name)}
//               </Text>
//             </div>
//           )}
//         </div>
//       </Link>
//       <div className={styles.details}>
//         <Text
//           Tag="h2"
//           size={TextSizes.secondaryTitleLrg}
//           className={styles.name}
//         >
//           {name}
//         </Text>
//         <Text
//           Tag="h3"
//           size={TextSizes.primaryTitleSml}
//           className={styles.jobTitle}
//         >
//           {jobTitle}
//         </Text>
//         <Button
//           variant={ButtonVariants.textLinkSmallUnderline}
//           link={hasArticles ? `/articles?author=${name}#all-articles` : slug}
//           className={styles.ctaButton}
//         >
//           {hasArticles ? `View ${articleCount} articles` : 'View Profile'}
//         </Button>
//       </div>
//     </div>
//   )
// }
// export default function ContributorList({
//   list,
//   theme = ComponentTheme.primary,
//   verticalPadding,
//   noPaddingBottom,
//   testID,
//   title,
// }: ContributorListProps) {
//   const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)
//   const renderDesktopView = () => (
//     <Grid>
//       <Row>
//         {list.map((member: TeamMemberProfileProps) => (
//           <Col
//             variant="col-1/2--sm col-1/3--md col-1/3--hg"
//             key={member._id}
//             cssClass={styles.item}
//           >
//             <ContributorProfile {...member} />
//           </Col>
//         ))}
//       </Row>
//     </Grid>
//   )
//   const renderMobileView = () => {
//     const groupedList = list.reduce<TeamMemberProfileProps[][]>(
//       (acc, member, i) => {
//         if (i % 3 === 0) acc.push([])
//         acc[acc.length - 1].push(member)
//         return acc
//       },
//       []
//     )
//     return (
//       <Slider
//         slidesPerView={1.15}
//         slidesPerViewMed={2}
//         slidesPerViewLrg={3}
//         slidesPerViewHuge={4}
//         overflowVisible={true}
//         title={''}
//         spaceBetween={0}
//         hideArrowsMobile
//         wrapperClass={styles.sliderWrapperClass}
//       >
//         {groupedList.map((group, i) => (
//           <div className={styles.contributorMobileWrap} key={`group-${i}`}>
//             {group.map((member, j) => (
//               <ContributorProfile
//                 {...member}
//                 key={`contributor-${member._id}`}
//               />
//             ))}
//           </div>
//         ))}
//       </Slider>
//     )
//   }
//   return (
//     <Fixture
//       verticalPadding={verticalPadding}
//       theme={theme}
//       noPaddingBottom={noPaddingBottom}
//     >
//       <div
//         className={classnames(
//           styles.base,
//           noPaddingBottom && styles.noPaddingBottomBase
//         )}
//         data-testid={testID}
//       >
//         <Container className={isMobile ? 'noPaddingRight' : ''}>
//           <div className={styles.sectionTitleSectionContainer}>
//             <div className={styles.sectionTitleSection}>
//               <Text
//                 size={TextSizes.primaryTitleLrg}
//                 className={styles.sectionTitle}
//               >
//                 {!isMobile && 'Contributing'} {title}
//               </Text>
//             </div>
//           </div>
//           {isMobile ? renderMobileView() : renderDesktopView()}
//         </Container>
//       </div>
//     </Fixture>
//   )
// }
import { useTranslations } from 'next-intl'

import classnames from 'classnames'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Container from '~/components/atoms/Container/Container'
import DynamicSlider from '~/components/atoms/DynamicSlider'
import Fixture from '~/components/atoms/Fixture/Fixture'
import { Col, Grid, Row } from '~/components/atoms/Grid'
import Image from '~/components/atoms/Image/Image'
import Link from '~/components/atoms/Link/Link'
import type { TeamMemberProfileProps } from '~/components/atoms/TeamMemberProfile/TeamMemberProfile'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { ComponentTheme } from '~/components/themes'
import { useMediaQuery } from '~/services/useMediaQuery'
import bp from '~/styles/breakpoints/breakpoints'
import firstLettersConcatenated from '~/utils/firstLetterConcatenated'

import styles from './ContributorList.module.css'

export interface ContributorListProps {
  list: TeamMemberProfileProps[]
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  title?: string
  slug?: string
}

const ContributorProfile = ({
  name,
  image,
  jobTitle,
  articleCount,
  slug,
}: TeamMemberProfileProps) => {
  const t = useTranslations('ourPeople')
  const hasArticles = articleCount && articleCount > 0
  const imageLink =
    hasArticles && !image?.asset
      ? `/articles?author=${name}#all-articles`
      : `/${slug}`

  return (
    <div className={styles.contributorWrap}>
      <Link href={imageLink}>
        <div className={classnames(styles.avatar)}>
          {image?.asset ? (
            <div className={styles.imageWrapper}>
              <Image
                asset={image.asset}
                alt={name}
                width={96}
                loading="lazy"
                className={styles.profileImage}
              />
            </div>
          ) : (
            <div className={styles.intialsFallback}>
              <Text size={TextSizes.secondaryTitleMicro}>
                {firstLettersConcatenated(name)}
              </Text>
            </div>
          )}
        </div>
      </Link>
      <div className={styles.details}>
        <Text
          Tag="h2"
          size={TextSizes.secondaryTitleLrg}
          className={styles.name}
        >
          {name}
        </Text>
        <Text
          Tag="h3"
          size={TextSizes.primaryTitleSml}
          className={styles.jobTitle}
        >
          {jobTitle}
        </Text>
        <Button
          variant={ButtonVariants.textLinkSmallUnderline}
          link={hasArticles ? `/articles?author=${name}#all-articles` : slug}
          className={styles.ctaButton}
        >
          {hasArticles
            ? t('viewArticles', { count: articleCount })
            : t('viewProfile')}
        </Button>
      </div>
    </div>
  )
}

const ContributorList = ({
  list,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  testID,
  title,
}: ContributorListProps) => {
  const t = useTranslations('ourPeople')
  const isMobile = useMediaQuery(`(max-width: ${bp.bpMedium})`)

  const renderDesktopView = () => (
    <Grid>
      <Row>
        {list.map((member: TeamMemberProfileProps) => (
          <Col
            variant="col-1/2--sm col-1/3--md col-1/3--hg"
            key={member._id}
            cssClass={styles.item}
          >
            <ContributorProfile {...member} />
          </Col>
        ))}
      </Row>
    </Grid>
  )

  const renderMobileView = () => {
    const groupedList = list.reduce<TeamMemberProfileProps[][]>(
      (acc, member, i) => {
        if (i % 3 === 0) acc.push([])
        acc[acc.length - 1].push(member)
        return acc
      },
      []
    )

    return (
      <DynamicSlider
        slidesPerView={1.15}
        slidesPerViewMed={2}
        slidesPerViewLrg={3}
        slidesPerViewHuge={4}
        overflowVisible={true}
        title={''}
        spaceBetween={0}
        hideArrowsMobile
        wrapperClass={styles.sliderWrapperClass}
      >
        {groupedList.map((group, i) => (
          <div className={styles.contributorMobileWrap} key={`group-${i}`}>
            {group.map(member => (
              <ContributorProfile
                {...member}
                key={`contributor-${member._id}`}
              />
            ))}
          </div>
        ))}
      </DynamicSlider>
    )
  }

  return (
    <Fixture
      verticalPadding={verticalPadding}
      theme={theme}
      noPaddingBottom={noPaddingBottom}
    >
      <div
        className={classnames(
          styles.base,
          noPaddingBottom && styles.noPaddingBottomBase
        )}
        data-testid={testID}
      >
        <Container className={isMobile ? 'noPaddingRight' : ''}>
          <div className={styles.sectionTitleSectionContainer}>
            <div className={styles.sectionTitleSection}>
              <Text
                size={TextSizes.primaryTitleLrg}
                className={styles.sectionTitle}
              >
                {!isMobile && t('contributing')} {title}
              </Text>
            </div>
          </div>

          {isMobile ? renderMobileView() : renderDesktopView()}
        </Container>
      </div>
    </Fixture>
  )
}

export default ContributorList
